export interface NormalizedMcpCallSocketMessage {
  payload: unknown;
  clientRequestId?: string;
  nodeId?: string;
}

export function normalizeMcpCallSocketData(
  data: unknown,
): NormalizedMcpCallSocketMessage {
  if (
    data !== null &&
    typeof data === 'object' &&
    !Array.isArray(data) &&
    'mcpPayload' in data
  ) {
    const o = data as Record<string, unknown>;
    return {
      payload: o.mcpPayload,
      clientRequestId:
        typeof o.clientRequestId === 'string' ? o.clientRequestId : undefined,
      nodeId: typeof o.nodeId === 'string' ? o.nodeId : undefined,
    };
  }
  return { payload: data };
}

function tryPrettyJson(value: string): string {
  const trimmed = value.trim();
  if (
    (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
    (trimmed.startsWith('[') && trimmed.endsWith(']'))
  ) {
    try {
      return JSON.stringify(JSON.parse(trimmed), null, 2);
    } catch {
      // not valid JSON, return as-is
    }
  }
  return value;
}

function extractMcpContentText(payload: unknown): string | null {
  if (
    payload == null ||
    typeof payload !== 'object' ||
    Array.isArray(payload)
  ) {
    return null;
  }
  const p = payload as Record<string, unknown>;
  if (!Array.isArray(p.content)) return null;
  const parts: string[] = [];
  for (const item of p.content as unknown[]) {
    if (
      item != null &&
      typeof item === 'object' &&
      !Array.isArray(item) &&
      (item as Record<string, unknown>).type === 'text'
    ) {
      const t = (item as Record<string, unknown>).text;
      if (typeof t === 'string') {
        parts.push(tryPrettyJson(t));
      }
    }
  }
  return parts.length > 0 ? parts.join('\n\n') : null;
}

export function mcpPayloadToOutputText(payload: unknown): {
  text: string;
  isError: boolean;
  errorMessage?: string;
} {
  const isError =
    payload != null && typeof payload === 'object' && 'error' in payload;
  const errPart = isError
    ? (payload as { error: unknown }).error
    : undefined;

  if (!isError) {
    const extracted = extractMcpContentText(payload);
    if (extracted !== null) {
      return { text: extracted, isError: false };
    }
  }

  const textValue = isError
    ? typeof errPart === 'string'
      ? errPart
      : JSON.stringify(errPart, null, 2)
    : typeof payload === 'string'
      ? tryPrettyJson(payload)
      : JSON.stringify(payload, null, 2);
  return {
    text: textValue,
    isError,
    errorMessage:
      isError && typeof errPart === 'string' ? errPart : undefined,
  };
}
